import axios from 'axios'
import {apiBaseUrl} from '../../../helpers/UrlHelper'
import {loginToken} from '../../../helpers/LocalStorageHelper'
import {handleError, handleSuccess} from '../../../helpers/ErrorHelper'
import store from '../../../Store'
import {scrollToError} from '../../../helpers/ScrollHelper'
import {
    cancelDiscountFormDispatch,
    discountFormServerValidationErrors
} from "../../../pages/discount-slab/form/DiscountForm-Action";

function _success(success) {
    return {type: 'UPDATE_DISCOUNT_SUCCESS', success}
}

function _error(error) {
    return {type: 'UPDATE_DISCOUNT_ERROR', error}
}

function _processing(processing) {
    return {type: 'UPDATE_DISCOUNT_PROCESSING', processing}
}

function updateDiscount(id) {
    return (dispatch, getState) => {

        let {discountForm} = getState()
        dispatch(_success(null))
        dispatch(_error(null))
        dispatch(_processing(true))

        axios({
            url: apiBaseUrl(`admin/discount_slabs/${id}`),
            method: 'put',
            dataType: 'json',
            data: discountForm.data.payload,
            headers: {
                'Authorization': 'Bearer ' + loginToken()
            }
        })
            .then(function (res) {
                dispatch(_success(res))
                dispatch(_processing(false))
                handleSuccess(res)
                store.dispatch(cancelDiscountFormDispatch())

            }).catch(function (error) {
            dispatch(_error(error.response.data.message))
            dispatch(_processing(false))
            handleError(error)

            store.dispatch(cancelDiscountFormDispatch())
            if (error.response && error.response.status === 422) {
                store.dispatch(discountFormServerValidationErrors(error.response.data.errors))
                scrollToError()
            }
        })
    }
}

export default updateDiscount
